"use strict";

var _objectWithoutProperties = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _defineProperty = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _excluded = ["reserveAuctions", "currentBids", "currentAsk"],
    _excluded2 = ["amount", "currency"],
    _excluded3 = ["amount"],
    _excluded4 = ["amount"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAuctionInformation = exports.transformCurrencyForKey = exports.auctionDataToPricing = exports.transformMediaForKey = exports.transformMediaItem = exports.transformCurrencyEth = exports.NULL_ETH_CURRENCY_ID = void 0;

var tslib_1 = require("tslib");

var big_js_1 = tslib_1.__importDefault(require("big.js"));

var FetchResultTypes_1 = require("./FetchResultTypes");

var RequestError_1 = require("./RequestError");

var AuctionInfoTypes_1 = require("./AuctionInfoTypes");

var AuctionState_1 = require("./AuctionState");

var addresses_1 = require("../constants/addresses");

exports.NULL_ETH_CURRENCY_ID = '0x0000000000000000000000000000000000000000';

function transformCurrencyEth(currency) {
  var updatedCurrency = _objectSpread({}, currency);

  if (currency.id === exports.NULL_ETH_CURRENCY_ID) {
    updatedCurrency.decimals = 18;
    updatedCurrency.name = 'Ethereum';
    updatedCurrency.symbol = 'ETH';
  }

  if (!updatedCurrency.decimals) {
    // Assume default 18 decimals
    updatedCurrency.decimals = 18;
  }

  return updatedCurrency;
}

exports.transformCurrencyEth = transformCurrencyEth;

function transformMediaItem(media, networkId) {
  var reserveAuctions = media.reserveAuctions,
      currentBids = media.currentBids,
      currentAsk = media.currentAsk,
      nft = _objectWithoutProperties(media, _excluded); // Since auctions are sorted by last created, the first auction will be the active auction
  // If the auction is not active it still will be created but will not be added to the current
  // auction information.


  var auctionData = reserveAuctions && reserveAuctions.length > 0 ? reserveAuctions[0] : undefined;
  return {
    nft: {
      tokenId: nft.id,
      contract: {
        address: addresses_1.ZORA_MEDIA_CONTRACT_BY_NETWORK[networkId],
        knownContract: FetchResultTypes_1.KNOWN_CONTRACTS.ZORA
      },
      owner: nft.owner.id,
      creator: nft.creator.id,
      metadataURI: nft.metadataURI
    },
    zoraNFT: {
      metadataURI: nft.metadataURI,
      metadataHash: nft.metadataHash,
      contentURI: nft.contentURI,
      contentHash: nft.contentHash,
      creatorBidShare: nft.creatorBidShare,
      ownerBidShare: nft.ownerBidShare,
      createdAtTimestamp: nft.createdAtTimestamp,
      creatorBidSharePercentage: new big_js_1.default(nft.creatorBidShare).div(new big_js_1.default(10).pow(18)).toNumber(),
      ownerBidSharePercentage: new big_js_1.default(nft.ownerBidShare).div(new big_js_1.default(10).pow(18)).toNumber()
    },
    pricing: {
      perpetual: {
        bids: currentBids || [],
        ask: currentAsk || null
      },
      reserve: auctionDataToPricing(auctionData)
    }
  };
}

exports.transformMediaItem = transformMediaItem;

function transformMediaForKey(result, key, networkId) {
  var media = result.id.find(function (media) {
    return media.id === key;
  });

  if (!media) {
    throw new RequestError_1.RequestError('No media in response');
  }

  return transformMediaItem(media, networkId);
}

exports.transformMediaForKey = transformMediaForKey;

function auctionDataToPricing(auctionData) {
  if (!auctionData) {
    return null;
  }

  return _objectSpread(_objectSpread({}, auctionData), {}, {
    auctionCurrency: transformCurrencyEth(auctionData.auctionCurrency)
  });
}

exports.auctionDataToPricing = auctionDataToPricing;

function transformCurrencyForKey(result, key) {
  var _a, _b; // Special case ETH


  if (key === exports.NULL_ETH_CURRENCY_ID) {
    return {
      ethToUsd: (_a = result.bundle) === null || _a === void 0 ? void 0 : _a.ethPrice,
      token: {
        symbol: 'ETH',
        name: 'Ethereum',
        id: exports.NULL_ETH_CURRENCY_ID,
        decimals: 18,
        derivedETH: 1
      }
    };
  }

  var currency = result.tokens.find(function (token) {
    return token.id === key;
  });

  if (!currency) {
    throw new RequestError_1.RequestError('No currency in response');
  }

  return {
    ethToUsd: (_b = result.bundle) === null || _b === void 0 ? void 0 : _b.ethPrice,
    token: currency
  };
}

exports.transformCurrencyForKey = transformCurrencyForKey;

var setCurrencyDecimal = function setCurrencyDecimal(amount, decimals) {
  return new big_js_1.default(amount).div(new big_js_1.default(10).pow(parseInt(decimals, 10) || 18)).toString();
};

function addAuctionInformation(pricing) {
  var currencyInfos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _a, _b, _c, _d, _e, _f, _g;

  var getCurrencyComputedValue = function getCurrencyComputedValue(currencyId, bidAmount) {
    var currencyInfo = currencyInfos[currencyId];

    if (!currencyInfo) {
      return;
    }

    var inETH = new big_js_1.default(currencyInfo.token.derivedETH).mul(new big_js_1.default(bidAmount).div(new big_js_1.default(10).pow(parseInt(currencyInfo.token.decimals, 10)))).toString();
    return {
      inETH: inETH,
      inUSD: new big_js_1.default(inETH).mul(currencyInfo.ethToUsd).toString()
    };
  };

  var handlePerpetualBid = function handlePerpetualBid(bidRaw) {
    var amount = bidRaw.amount,
        currency = bidRaw.currency,
        bid = _objectWithoutProperties(bidRaw, _excluded2);

    return _objectSpread(_objectSpread({}, bid), {}, {
      pricing: {
        currency: currency,
        amount: amount,
        prettyAmount: setCurrencyDecimal(amount, currency.decimals),
        computedValue: getCurrencyComputedValue(currency.id, amount)
      }
    });
  };

  var getBidPricing = function getBidPricing(amount) {
    var _a;

    var currency = (_a = pricing.reserve) === null || _a === void 0 ? void 0 : _a.auctionCurrency;
    return {
      pricing: {
        currency: currency,
        amount: amount,
        prettyAmount: setCurrencyDecimal(amount, currency === null || currency === void 0 ? void 0 : currency.decimals),
        computedValue: currency ? getCurrencyComputedValue(currency.id, amount) : undefined
      }
    };
  };

  var transformAskCurrency = function transformAskCurrency(ask) {
    var amount = ask.amount,
        currency = ask.currency,
        createdAtTimestamp = ask.createdAtTimestamp,
        id = ask.id;
    return {
      createdAtTimestamp: createdAtTimestamp,
      id: id,
      pricing: {
        currency: currency,
        amount: amount,
        prettyAmount: setCurrencyDecimal(amount, currency.decimals),
        computedValue: getCurrencyComputedValue(currency.id, amount)
      }
    };
  };

  var getHighestReserveBid = function getHighestReserveBid() {
    var _a;

    if ((_a = pricing.reserve) === null || _a === void 0 ? void 0 : _a.currentBid) {
      var _pricing$reserve = pricing.reserve,
          auctionCurrency = _pricing$reserve.auctionCurrency,
          currentBid = _pricing$reserve.currentBid;
      var computedValue = getCurrencyComputedValue(auctionCurrency.id, currentBid.amount);
      return {
        pricing: {
          amount: currentBid.amount,
          prettyAmount: setCurrencyDecimal(currentBid.amount, auctionCurrency.decimals),
          currency: transformCurrencyEth(auctionCurrency),
          computedValue: computedValue
        },
        placedBy: currentBid.bidder.id,
        placedAt: currentBid.createdAtTimestamp
      };
    }

    return;
  };

  var getHighestPerpetualBid = function getHighestPerpetualBid() {
    var _a, _b;

    var sortedBids = (_b = (_a = pricing.perpetual) === null || _a === void 0 ? void 0 : _a.bids) === null || _b === void 0 ? void 0 : _b.map(function (bid) {
      return {
        bid: bid,
        computedValue: getCurrencyComputedValue(bid.currency.id, bid.amount)
      };
    }).sort(function (a, b) {
      if (a.computedValue && b.computedValue) {
        return new big_js_1.default(a.computedValue.inETH).sub(b.computedValue.inETH).toNumber() > 0 ? -1 : 1;
      }

      return new Date(a.bid.createdAtTimestamp).getTime() > new Date(b.bid.createdAtTimestamp).getTime() ? -1 : 1;
    });

    if (!sortedBids || !sortedBids.length) {
      return;
    }

    return {
      pricing: {
        computedValue: sortedBids[0].computedValue,
        amount: sortedBids[0].bid.amount,
        prettyAmount: setCurrencyDecimal(sortedBids[0].bid.amount, sortedBids[0].bid.currency.decimals),
        currency: transformCurrencyEth(sortedBids[0].bid.currency)
      },
      placedBy: sortedBids[0].bid.bidder.id,
      placedAt: sortedBids[0].bid.createdAtTimestamp
    };
  };

  var nftPricingInformation = {
    reserve: pricing.reserve ? _objectSpread(_objectSpread({}, pricing.reserve), {}, {
      currentBid: function () {
        var _a;

        if (!pricing.reserve.currentBid) {
          return undefined;
        }

        var _ref = (_a = pricing.reserve) === null || _a === void 0 ? void 0 : _a.currentBid,
            amount = _ref.amount,
            bidRaw = _objectWithoutProperties(_ref, _excluded3);

        return _objectSpread(_objectSpread({}, bidRaw), getBidPricing(amount));
      }(),
      current: {
        highestBid: getHighestReserveBid(),
        likelyHasEnded: parseInt((_a = pricing.reserve) === null || _a === void 0 ? void 0 : _a.expectedEndTimestamp, 10) < new Date().getTime() / 1000,
        reserveMet: ((_b = pricing.reserve) === null || _b === void 0 ? void 0 : _b.firstBidTime) && pricing.reserve.firstBidTime !== '0'
      },
      reservePrice: {
        currency: transformCurrencyEth({
          id: pricing.reserve.auctionCurrency.id,
          name: pricing.reserve.auctionCurrency.name,
          symbol: pricing.reserve.auctionCurrency.symbol,
          decimals: pricing.reserve.auctionCurrency.decimals
        }),
        amount: pricing.reserve.reservePrice,
        prettyAmount: setCurrencyDecimal(pricing.reserve.reservePrice, pricing.reserve.auctionCurrency.decimals),
        computedValue: getCurrencyComputedValue(pricing.reserve.auctionCurrency.id, pricing.reserve.reservePrice)
      },
      previousBids: ((_d = (_c = pricing.reserve) === null || _c === void 0 ? void 0 : _c.previousBids) === null || _d === void 0 ? void 0 : _d.map(function (_ref2) {
        var amount = _ref2.amount,
            previousBid = _objectWithoutProperties(_ref2, _excluded4);

        return _objectSpread(_objectSpread({}, previousBid), getBidPricing(amount));
      }).sort(function (bidA, bidB) {
        return bidA.bidInactivatedAtBlockNumber > bidB.bidInactivatedAtBlockNumber ? -1 : 1;
      })) || []
    }) : undefined,
    perpetual: {
      ask: ((_e = pricing.perpetual) === null || _e === void 0 ? void 0 : _e.ask) ? transformAskCurrency(pricing.perpetual.ask) : undefined,
      bids: ((_f = pricing.perpetual) === null || _f === void 0 ? void 0 : _f.bids.map(function (bid) {
        return handlePerpetualBid(bid);
      })) || [],
      highestBid: getHighestPerpetualBid()
    },
    auctionType: ((_g = pricing.reserve) === null || _g === void 0 ? void 0 : _g.status) === 'Active' ? AuctionInfoTypes_1.AuctionType.RESERVE : pricing.perpetual ? AuctionInfoTypes_1.AuctionType.PERPETUAL : AuctionInfoTypes_1.AuctionType.NONE,
    status: AuctionState_1.AuctionStateInfo.LOADING
  };
  nftPricingInformation.status = AuctionState_1.getAuctionState(nftPricingInformation);
  return nftPricingInformation;
}

exports.addAuctionInformation = addAuctionInformation;